import { render, staticRenderFns } from "./ExportINIFile.vue?vue&type=template&id=267ca87e"
import script from "./ExportINIFile.vue?vue&type=script&lang=js"
export * from "./ExportINIFile.vue?vue&type=script&lang=js"
import style0 from "./ExportINIFile.vue?vue&type=style&index=0&id=267ca87e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports